var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-btn',_vm._b({},'b-btn',_vm.$attrs,false),[_c('div',{staticClass:"d-flex align-items-center"},[(_vm.loading)?_c('b-spinner',{staticClass:"align-middle mr-2",attrs:{"small":""}}):(_vm.icon)?_c('font-awesome-icon',{staticClass:"mr-2",attrs:{"icon":_vm.icon}}):_vm._e(),_vm._t("default",function(){return [_vm._v("Submit")]})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }